export default "__VITE_ASSET__VdTPXlWf__"